import { type FC, type ReactNode, Children } from "react";
import { type ClassNameProp, Grid } from "@huub-web/ui";
import { mergeClasses } from "@huub-web/utils";

export type TriptychProps = ClassNameProp & {
  children: ReactNode;
};

export const Triptych: FC<TriptychProps> = ({ children, className }) => {
  const childrenArray = Children.toArray(children);

  return (
    <Grid className={mergeClasses(className)} variant="twoColumnMarketing">
      {childrenArray[0]}
      <Grid variant="oneColumn">
        {childrenArray[1]}
        {childrenArray[2]}
      </Grid>
    </Grid>
  );
};
